import type { AddonsInsightsReportState } from './AddonsInsightsReportState';
import { initialAddonsInsightsReportState, emptyAddonsInsightsReport } from './AddonsInsightsReportState';
import type { AddonsInsightsReportAction } from 'actions/insights/sales/addonsInsightsReport/AddonsInsightsReportActionsTypes';

import {
    ADDONS_INSIGHTS_REPORT_GET_ERROR,
    ADDONS_INSIGHTS_REPORT_GET_START,
    ADDONS_INSIGHTS_REPORT_GET_SUCCESS
} from 'actions/insights/sales/addonsInsightsReport/AddonsInsightsReportActionsTypes';

export const addonsInsightsReportReducer = (
    state: AddonsInsightsReportState = initialAddonsInsightsReportState,
    action: AddonsInsightsReportAction
): AddonsInsightsReportState => {
    switch (action.type) {
        case ADDONS_INSIGHTS_REPORT_GET_START:
            return { ...state, loading: true };

        case ADDONS_INSIGHTS_REPORT_GET_SUCCESS:
            return { loading: false, report: action.payload.report };

        case ADDONS_INSIGHTS_REPORT_GET_ERROR:
            return { loading: false, report: emptyAddonsInsightsReport() };

        default:
            return state;
    }
};
